/**
 * Created by dvircohen on 02/06/2016.
 */
(function () {
    'use strict';

    // @ngInject
    function CreateExampleProposalControllerCtor($scope, $injector, $modalInstance, AnalyticsService, UserService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CreateExampleProposalControllerCtor';
        AnalyticsService.trackPageView(this, 'CreateExampleProposalModalView');
        
        this.$modalInstance = $modalInstance;
        this.UserService = UserService;
    }

    Controllers.CreateExampleProposalController = Class(Controllers.BaseController, {
        constructor: CreateExampleProposalControllerCtor,
        
        cancel: function cancel() {
            this.$modalInstance.dismiss();
        },
        
        confirm: function confirm() {

            this.requestInProgress = true;
            this.UserService.createExampleProposal().then(function() {
                this.$modalInstance.close();
            }.bind(this)).finally(function () {
                this.requestInProgress = false;
            }.bind(this));
        }
    });
}());
